// Convert TrustArc GDPR Consent to Shopify consent

// trustArcConsent is an array containing values 0 - 3. these value represent:
// 0: the user has not asserted any consent, and has implied consent only for required cookies.
// 1: the user has asserted consent to required cookies.
// 2: the user has asserted consent to functional cookies.
// 3: the user has asserted consent to advertising cookies.
export const trustArcToShopifyConsent = (trustArcConsent) => {
  const shopifyConsent = {
    analytics: false,
    preferences: false,
    marketing: false,
    saleOfData: false,
  };

  if (trustArcConsent.includes(3)) {
    shopifyConsent.analytics = true;
    shopifyConsent.preferences = true;
    shopifyConsent.marketing = true;
  }

  return shopifyConsent;
};
